import React from "react";
import SlideoutEnabledContext from "pages/waitlist-update/context";
import { getActivityFeed_activityFeed_metadata as ActivityFeedMetadataType } from "types/gql-types";

type Props = {
  interestId: string;
  metadata: ActivityFeedMetadataType | null;
}

export const NotDuplicateFeedItem:React.FC<Props> = ({ metadata, interestId }) => {
  const { slideoutEnabled } = React.useContext(SlideoutEnabledContext);
  return (
    <div style={{ marginBottom: 10 }}>
      <div>Matched as Not Duplicate against these applications:</div>
      {metadata?.otherInterests
        ?.filter((x) => x && x.id !== interestId)
        .map((x) => {
          if (!x) return null;

          const profileUrl = slideoutEnabled ? (
            `interests/${x.id}/activity`
          ) : (
            `/dash/manager/interest/${x.id}/activity`
          );
          const inNewTab = slideoutEnabled ? {} : { target: "_blank" };
          return (
            <a
              key={x.id}
              href={profileUrl}
              style={{ display: "block" }} rel="noreferrer"
              {...inNewTab}
            >
              {x.firstName || "N/A"} {x.lastName || "N/A"}
            </a>
          );
        })}
    </div>
  );
};
